/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {
    AccountCircleOutlined,
    GeneratingTokensOutlined,
    Google,
    MoneyOutlined,
    QrCode2Outlined
} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import IngresoImagen from "../../../Modulo_formularios/Componentes/IngresoImagen";
import IngresoSelectFuncion from "../../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {CRYPTOS} from "../../../Constantes";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import {QRCodeSVG} from 'qrcode.react';
import {copiarPortapapeles} from "../../../CodNegocio/Funciones/copiarPortapapeles";
import IngresoTextoBoton from "../../../Modulo_formularios/Componentes/IngresoTextoBoton";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {getID} from "../../../Servicios/BD/useEscucharUsuarioToCorreo";
import {obtenerDoc} from "../../../Servicios/BD/obtenerDoc";
import logo from '../../../Recursos/logo_redondo.svg'

const Formulario_Deposito_Crear = ({...props}) => {
    const {Avisos, nuevoAviso, terminar, iniciarCarga, Cargador} = useCargador({logoRedondo: logo})
    const [crypto, setCrypto] = useState({});
    const [billetera, setBilletera] = useState({});

    const buscar = async () => {

        let pal = props.props.getValues("correo");

        if (!pal) {
            return
        }

        iniciarCarga('Buscando')

        let pala = pal.replaceAll(' ', '')
        let id = getID(pala)
        let result = await obtenerDoc('cuentas', id)
        if (result.res) {
            let usuario = result.data
            props.props.setValue('idUsuario', usuario.id)
            props.props.setValue('nombre', usuario.nombre)
            props.props.setValue('codigoUsuario', usuario.codigo)

            terminar({aviso: 'Usuario encontrado'})
        } else {
            terminar({aviso: 'No hay cuenta registrada con este correo.', variante: 'error'})
        }

    }


    useEffect(() => {

        if (crypto) {

            let index = CRYPTOS.findIndex((e) => e.nombre === crypto);
            if (index > -1) {
                setBilletera(CRYPTOS[index]);
            }

        }
    }, [crypto]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >
                <Cargador/>

                <Avisos/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoBoton nombre={'Correo de usuario'} {...props} dato={'correo'} Icono={Google}
                                       click={buscar}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor en USD'} dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFuncion Icono={GeneratingTokensOutlined} nombre={'Tipo de Crypto'}
                                          dato={'tipo'} {...props}
                                          opciones={CRYPTOS.map((it) => it.nombre)}
                                          setDato={setCrypto}
                                          requerido={'El tipo de Crypto es requerido'}
                    />
                </Grid>

                {billetera.key &&

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                                <QRCodeSVG value={billetera.key}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'center'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography
                                            sx={{wordBreak: 'break-word', textAlign: 'center'}}
                                        >{billetera.key}</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Button
                                            onClick={() => copiarPortapapeles(billetera.key).then(() => {
                                                terminar({aviso: 'Copiado a portapapales'})
                                            })}
                                            sx={{px: 2, py: 0.5}} variant={'outlined'}>Copiar</Button>
                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography sx={{fontWeight: 600}}>Envio de Captura de Pantalla</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <IngresoImagen dato={'img'} {...props} />
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 12}}>**La validacion puede tardar hasta 12 horas, podras ver
                                    el estado de esta en la seccion historial (historial de transacciones)</Typography>
                            </Grid>


                        </Grid>

                    </Grid>


                }

            </Grid>


        </form>

    )

}
export default Formulario_Deposito_Crear